var map = {
	"./swedbankpay-logo-h-neg.png": 3006,
	"./swedbankpay-logo-h-neg.svg": 5017,
	"./swedbankpay-logo-h.png": 483,
	"./swedbankpay-logo-h.svg": 9220,
	"./swedbankpay-logo-v-neg.png": 9016,
	"./swedbankpay-logo-v-neg.svg": 2823,
	"./swedbankpay-logo-v.png": 6765,
	"./swedbankpay-logo-v.svg": 7362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3082;